export const defaultDesign = {
    font_family: 'Roboto',
    question: '50,50,50,1',
    background_color: '255, 255, 255, 1',
    bar: '64, 80, 181, 1'
}